import { Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { LOGGED_USER } from "../../variables/constants";
import axiosInstance from "../../variables/api/axiosInstance";
import { searchProfil } from "../../hooks/useSearch";

const AddProfil = () => {
  const [organismes, setOrganismes] = useState([]);
  const [modules, setModules] = useState([]);
  const [habilitations, setHabilitations] = useState([]);
  const [selectedHabilitations, setSelectedHabilitations] = useState([]);
  const [profil, setProfil] = useState();
  const [loading, setLoading] = useState(false);
  const [profils, setProfils] = useState([]);
  const [profilSearch, setProfilSearch] = useState(null);

  const [formData, setFormData] = useState({
    libelle: "",
    description: "",
    organisme: "",
    typeProfil: "",
  });

  const [choices, setChoices] = useState([]);

  const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.libelle) newErrors.username = "Libellé requis";
  //   if (!formData.description) newErrors.email = "Description requise";
  //   if (!formData.organisme)
  //     newErrors.organisme = "Organisme requis";
  //   setErrors(newErrors);

  //   return Object.keys(newErrors).length === 0;
  // };

  const param = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL") {
      setFormData({
        ...formData,
        organisme: LOGGED_USER?.profil?.organisme?.code,
      });
    }
    axiosInstance
      .get(`/api/organisme/all/assurances-pool`)
      .then((res) => {
        setOrganismes(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axiosInstance
      .get(`/api/habilitation/used`)
      .then((res) => {
        console.log("res.data ", res.data);
        setHabilitations(res.data);
        let habs = [];
        res.data.forEach((hab, id) => {
          habs.push({
            key: id,
            label: hab.libelle,
            value: hab.habilitationId,
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });

    axiosInstance
      .get(`/api/profil`)
      .then((res) => {
        console.log(res.data);
        setProfils(res.data.content);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (param.profilId) {
      axiosInstance
        .get(`/api/profil/codeId/${param.profilId}`)
        .then((res) => {
          setProfil(res.data);
          setSelectedHabilitations(res.data.habilitations);

          setFormData({
            libelle: res.data.nom,
            description: res.data.commentaire,
            organisme: res.data?.organisme && res.data?.organisme.code,
            typeProfil: "",
          });

          axiosInstance
            .get(`/api/module`)
            .then((response) => {
              let c = [];
              response?.data?.forEach((md, id) => {
                let habs = res?.data?.habilitations?.filter(
                  (e) => e.module.moduleId === md.moduleId
                );
                let hs = [];
                if (habs) {
                  habs.forEach((h) => {
                    hs.push(h.habilitationId);
                  });
                }
                c.push(hs);
              });
              setChoices(c);
              setModules(response.data);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axiosInstance
        .get(`/api/module`)
        .then((res) => {
          let c = [];
          res.data.forEach((md) => {
            c.push([]);
          });
          setChoices(c);
          setModules(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [param.profilId]);

  const handleSelectChange = (value, id) => {
    // console.log("Selected habilitations: ", value);
    let c = [...choices];
    c[id] = value;
    let selectedHabs = [];
    c.forEach((habs) => {
      habs.forEach((el) => {
        let h = habilitations.find((e) => e.habilitationId === parseInt(el));
        selectedHabs.push(h);
      });
    });
    setChoices(c);
    setSelectedHabilitations(selectedHabs);
  };

  // Fonction qui filtre les habilitations afin de ressortir celles d'un module spécifique défini par son moduleId
  const getHabilitationsOfModule = (moduleId, moduleNom) => {
    let habs = habilitations.filter((e) => e.module.moduleId === moduleId || e.module.nom.toLowerCase().trim() === moduleNom.toLowerCase().trim());
    let opt = [];
    habs.forEach((hab, id) => {
      opt.push({
        key: id,
        label: hab.libelle,
        value: hab.habilitationId,
      });
    });
    return opt;
  };

  const getUpdateHabilitationsOfModule = (moduleId) => {
    // console.log("The choice: ", choices);
    // console.log(selectedHabilitations);
    let habs = selectedHabilitations?.filter(
      (e) => e?.module?.moduleId === moduleId
    );
    // console.log("habits...: ", habs);
    let opt = [];
    habs?.forEach((hab, id) => {
      opt?.push({
        key: id,
        label: hab.libelle,
        value: hab.habilitationId,
      });
    });
    return opt;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let org = organismes.find(
      (e) => e.code === formData.organisme
    );
    console.log("Organisme choisi: ", org);

    if (param.profilId) {
      profil.nom = formData.libelle;
      profil.commentaire = formData.description;
      profil.habilitations = selectedHabilitations;
      profil.organisme = org;

      // console.log("Hable submit: ", profil);
      axiosInstance
        .put(`/api/profil`, JSON.stringify(profil))
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          navigate("/profils");
          toast("Profil modifié avec succès");
        })
        .catch((err) => {
          console.log(err);
          toast("Erreur lors de l'ajout du profil");
          setLoading(false);
        });
    } else {
      let habit = {
        nom: formData.libelle,
        commentaire: formData.description,
        habilitations: selectedHabilitations,
        organisme: org,
      };

      // console.log("Hable submit: ", habit);

      axiosInstance
        .post(`/api/profil`, JSON.stringify(habit))
        .then((res) => {
          // console.log(res.data);
          setLoading(false);
          navigate("/profils");
          toast("Profil ajouté avec succès");
        })
        .catch((err) => {
          console.log(err);
          toast("Erreur lors de l'ajout du profil");
          setLoading(false);
        });
    }
  };

  const getUniqueHabilitationsFromCopiedProfils = (arrayOfDataObjects) => {
    if (!Array.isArray(arrayOfDataObjects)) {
      console.warn("Input is not an array. Returning empty array.");
      return [];
    }

    const allHabilitations = [];

    // 1. Collect all habilitations from all data objects
    arrayOfDataObjects.forEach((dataObject) => {
      if (
        dataObject &&
        dataObject.data &&
        Array.isArray(dataObject.data.habilitations)
      ) {
        allHabilitations.push(...dataObject.data.habilitations);
      }
    });

    // 2. De-duplicate the collected habilitations
    const uniqueHabilitationsMap = new Map();

    allHabilitations.forEach((hab) => {
      // Ensure 'codeId' exists for de-duplication
      if (hab && hab.habilitationId) {
        uniqueHabilitationsMap.set(hab.habilitationId, hab);
      }
    });

    // 3. Convert Map values back to an array
    return Array.from(uniqueHabilitationsMap.values());
  }


  const handleSelectProfilsToCopy = (_, records) => {
    // console.log(getUniqueHabilitationsFromCopiedProfils(records));
    let allHabs = getUniqueHabilitationsFromCopiedProfils(records);
    let c = [];
    modules.forEach((md, id) => {
      let habs = allHabs.filter(
        (e) => e.module.moduleId === md.moduleId
      );
      let hs = [];
      if (habs) {
        habs.forEach((h) => {
          hs.push(h.habilitationId);
        });
      }
      c.push(hs);
    });
    setChoices(c);
    setSelectedHabilitations(allHabs);
  }

  const debouncedSetProfilSearchInput = useCallback((value) => {
    const handler = setTimeout(() => {
      setProfilSearch(value);
    }, 10); // Wait 500ms after user stops typing
    // Clean up previous timeout
    return () => clearTimeout(handler);
  }, []);

  useEffect(() => {
    searchProfil(profilSearch).then((res) => {
      // console.log(res.data.content);
      setProfils(res.data?.content);
    }).catch((err) => {
      console.log(err);
    });
  }, [profilSearch]);

  return (
    <div class="layout-wrapper layout-content-navbar  ">
      <div class="layout-container">
        <SideBar currentMenu={"PROFILS"} />

        {/* <!-- Layout container --> */}
        <div class="layout-page">
          <NavBar />

          {/* <!-- Content wrapper --> */}
          <div class="content-wrapper">
            {/* <!-- Content --> */}
            <div class="container-xxl flex-grow-1 container-p-y">
              <div class="row">
                <div class="row my-6">
                  <div class="col">
                    <h6>
                      {" "}
                      {param.profilId
                        ? "Modifier le"
                        : "Ajouter un nouveau"}{" "}
                      profil{" "}
                    </h6>
                    <div class="accordion" id="collapsibleSection">
                      <form onSubmit={handleSubmit}>
                        <div class="card accordion-item">
                          <h2
                            class="accordion-header"
                            id="headingDeliveryAddress"
                          >
                            <button
                              type="button"
                              class="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseDeliveryAddress"
                              aria-expanded="true"
                              aria-controls="collapseDeliveryAddress"
                            >
                              {" "}
                              Informations sur le profil{" "}
                            </button>
                          </h2>
                          <div
                            id="collapseDeliveryAddress"
                            class="accordion-collapse collapse show"
                            data-bs-parent="#collapsibleSection"
                          >
                            <div class="accordion-body">
                              <div class="row g-6">
                                <div class="mb-6">
                                  <label
                                    class="form-label"
                                    for="basic-default-fullname"
                                  >
                                    Libellé
                                  </label>
                                  <input
                                    type="text"
                                    class={`form-control ${errors.libelle ? "is-invalid" : ""
                                      }`}
                                    id="libelle"
                                    placeholder="Libellé du profil"
                                    name="libelle"
                                    value={formData.libelle}
                                    onChange={handleInputChange}
                                  />
                                  {errors.libelle && (
                                    <div className="invalid-feedback">
                                      {errors.libelle}
                                    </div>
                                  )}
                                </div>


                                <div class="mb-6">
                                  <label class="form-label" for="organisme">
                                    Organisme
                                  </label>
                                  <select
                                    id="organisme"
                                    name="organisme"
                                    class={`form-control form-select ${errors.organisme ? "is-invalid" : ""
                                      }`}
                                    value={formData.organisme}
                                    onChange={handleInputChange}
                                    disabled={LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL"}
                                  >
                                    <option value="">
                                      Sélectionner l'organisme
                                    </option>
                                    {organismes?.map((org, id) => (
                                      <option
                                        key={id}
                                        value={org.code}
                                      >
                                        {org.raisonSociale}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div class="mb-6">
                                  <label class="form-label" for="commentaire">
                                    Description
                                  </label>
                                  <textarea
                                    type="text"
                                    class={`form-control ${errors.description ? "is-invalid" : ""
                                      }`}
                                    id="description"
                                    name="description"
                                    placeholder="Une brève description du profil"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card accordion-item">
                          <h2
                            class="accordion-header"
                            id="headingDeliveryOptions"
                          >
                            <button
                              type="button"
                              class="accordion-button collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseDeliveryOptions"
                              aria-expanded="false"
                              aria-controls="collapseDeliveryOptions"
                            >
                              {" "}
                              Habilitations{" "}
                            </button>
                          </h2>
                          <div
                            id="collapseDeliveryOptions"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingDeliveryOptions"
                            data-bs-parent="#collapsibleSection"
                          >
                            <div class="accordion-body">
                              <div class="row">
                                <div class="mb-6">
                                  <label class="form-label" for="organisme">
                                    Copier les habilitations des profils ...
                                  </label>
                                  <Select
                                    mode="multiple"
                                    showSearch
                                    style={{
                                      width: "100%",
                                    }}
                                    searchValue={profilSearch}
                                    onSearch={(value) => {
                                      console.log(value);
                                      debouncedSetProfilSearchInput(value);
                                    }}
                                    filterOption={false}
                                    placeholder="Veuillez sélectionner le(s) profil(s)"
                                    onChange={handleSelectProfilsToCopy}
                                    options={profils?.map((p) => {
                                      return {
                                        label: p.nom,
                                        value: p.codeId,
                                        data: p
                                      };
                                    })}
                                  />
                                </div>
                                {modules?.map((mod, id) => (
                                  <div
                                    class="col-md-12 select2-primary"
                                    key={id}
                                  >
                                    <label
                                      class="form-label"
                                      for="formtabs-language"
                                    >
                                      {mod?.nom}
                                    </label>
                                    <Select
                                      mode="multiple"
                                      style={{
                                        width: "100%",
                                      }}
                                      placeholder="Veuillez sélectionner les habilitations sur le module"
                                      onChange={(value) =>
                                        handleSelectChange(value, id)
                                      }
                                      options={getHabilitationsOfModule(
                                        mod.moduleId, mod.nom
                                      )}
                                      defaultValue={
                                        param.profilId
                                          ? getUpdateHabilitationsOfModule(
                                            mod.moduleId
                                          )
                                          : []
                                      }
                                      value={getUpdateHabilitationsOfModule(
                                        mod.moduleId
                                      )}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <button
                          type="submit"
                          class="btn btn-primary"
                          disabled={loading}
                        >
                          {loading && (
                            <span
                              class="spinner-grow me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                          {param.profilId
                            ? loading
                              ? "Mise à jour en cours ..."
                              : "Mettre à jour"
                            : loading
                              ? "Enregistrement..."
                              : "Ajouter"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- / Content --> */}

            {/* <!-- Footer --> */}
            <Footer />
            {/* <!-- / Footer --> */}

            <div class="content-backdrop fade"></div>
          </div>
          {/* <!-- Content wrapper --> */}
        </div>
        {/* <!-- / Layout page --> */}
      </div>

      {/* <!-- Overlay --> */}
      <div class="layout-overlay layout-menu-toggle"></div>

      {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
      <div class="drag-target"></div>
    </div>
  );
};

export default AddProfil;
